// extracted by mini-css-extract-plugin
var _1 = "greeting-file-select__nSx_l";
var _2 = "greeting-select__v0lM1";
var _3 = "inactive__RPUIX";
export { _1 as "greetingFileSelect", _2 as "greetingSelect", _3 as "inactive" }
